<template>
  <div class="protocol-gateway">
    <a-card>
      <!-- 查询区 -->
      <a-form layout="inline" class="search-bar">
        <a-form-item label="协议名称">
          <a-input v-model:value="searchParams.name" placeholder="请输入协议名称" style="width: 180px" />
        </a-form-item>
        <a-form-item label="协议code">
          <a-input v-model:value="searchParams.code" placeholder="请输入协议code" style="width: 180px" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">查询</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="handleReset">重置</a-button>
        </a-form-item>
      </a-form>
      <!-- 表格区 -->
      <a-table 
        :columns="columns" 
        :data-source="filteredDataSource" 
        :pagination="{
          total: filteredDataSource.length,
          pageSize: 15,
          current: pagination.current,
          showTotal: (total: any) => `共 ${total} 条记录`,
          onChange: (page: number, pageSize: number) => {
            pagination.current = page;
            pagination.pageSize = pageSize;
          }
        }" 
        style="margin-top: 16px;"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'action'">
            <a @click="() => goDetail(record)" style="color:#1677ff;">查看</a>
          </template>
          <template v-else-if="column.key === 'etcdKey'">
            <span>{{ record.etcdKey }} <a-icon type="copy" style="margin-left:4px;" /></span>
          </template>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { protocolDataList, ProtocolRecord } from '@/data/protocolData'

// 定义数据类型接口
// interface ProtocolRecord { // 已在 protocolData.ts 中定义，此处可以删除
//   index: number
//   type: string
//   name: string
//   etcdKey: string
//   code: string
//   trans: string
// }

// 搜索参数
const searchParams = ref({
  name: '',
  code: ''
})

const tabKey = ref('all')
const router = useRouter()

const columns = [
  { title: '序号', dataIndex: 'index', key: 'index' },
  { title: '协议类型', dataIndex: 'type', key: 'type' },
  { title: '协议名称', dataIndex: 'name', key: 'name' },
  { title: '协议etcdKey', dataIndex: 'etcdKey', key: 'etcdKey' },
  { title: '协议code', dataIndex: 'code', key: 'code' },
  { title: '传输协议', dataIndex: 'trans', key: 'trans' },
  { title: '操作', key: 'action' }
]

// 使用导入的数据列表
const dataSource = protocolDataList

const pagination = ref({
  total: dataSource.length,
  pageSize: 15,
  current: 1
})

// 过滤后的数据源
const filteredDataSource = computed(() => {
  return dataSource.filter(item => {
    const nameMatch = searchParams.value.name ? item.name.includes(searchParams.value.name) : true
    const codeMatch = searchParams.value.code ? item.code.includes(searchParams.value.code) : true
    return nameMatch && codeMatch
  })
})

// 搜索方法
function handleSearch() {
  pagination.value.current = 1 // 重置到第一页
}

// 重置方法
function handleReset() {
  searchParams.value.name = ''
  searchParams.value.code = ''
  pagination.value.current = 1 // 重置到第一页
}

// 添加参数类型
function goDetail(record: ProtocolRecord) {
  router.push(`/network/gateway/${record.code}`)
}
</script>

<style lang="less" scoped>
.protocol-gateway {
  .search-bar {
    margin-bottom: 12px;
  }
  .tab-bar {
    margin-bottom: 12px;
    display: flex;
    gap: 8px;
    .active {
      color: #1677ff;
      background: #e6f7ff;
      border-color: #91d5ff;
    }
  }
  .pagination-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
  }
}
</style>